export const PAGE_TEXT: Record<string, string> = {
  TITLE: 'Notice of Offer',
  INFORMATION_APPLICATION_NO: 'Application No',
  INFORMATION_APPLICANT_NAME: 'Applicant Name',
  INFORMATION_REF_NO: 'Ref. No',
  INFORMATION_DATE: 'Date',

  CONDITION_DEPARTMENT: 'Department',
  CONDITION_PROGRAMME: 'Programme',
  CONDITION_PROGRAMME_CODE: 'Programme Code',
  CONDITION_PROGRAMME_SUBCODE: 'Programme Subcode',
  CONDITION_MODE_OF_STUDY: 'Mode of Study',
  CONDITION_CREDIT_REQUIREMENT: 'Credit Requirements',
  CONDITION_DURATION: 'Normal duration',

  FACILITATE_TITLE:
    'To facilitate your planning and preparation, you may wish to read the announcement in advance.',

  REMARKS_TO_APPLICANT: 'Remarks to Applicant',

  ACCEPT_MY_OFFER: 'Accept Offer',
  DECLINE_MY_OFFER: 'Decline Offer',

  VISA_APPLICATION_STATUS: 'Visa Application Status',
  VISA_APPLICATION_REF_NO: 'Reference No',
  VISA_APPLICATION_UPDATE_DATE: 'Request Date',
  VISA_APPLICATION_RESULT: 'Status',
  VISA_APPLICATION_ISSUED_DATE: 'Issued Date',
  VISA_APPLICATION_REMARKS: 'Remarks (if any)',
  UPDATE_VISA_FILES: 'Update Visa Files',
  UPDATE_VISA_LABEL: 'Update Visa Label',
  UPDATE_ENTRY_SLIP: 'Update Entry Slip',
  UPDATE_VISA_LABEL_TEXT:
    'Please upload your visa label once downloaded from IMMD.',
  UPDATE_ENTRY_SLIP_TEXT:
    'Please upload your entry slip after your first entry to Hong Kong, if applicable.',

  OFFER_NOTICE_CONDITIONS: 'under the conditions below',

  MEETING_CONDITION_UPLOAD_FILES: 'Upload Files',
  MEETING_CONDITION_STATUS: 'Meeting Condition Status',
  MEETING_CONDITION_SUBMIT_APPLICATION: 'Submit',
  MEETING_CONDITION_SUBMIT_DATE: 'Request Date',
  MEETING_CONDITION_UPDATED_DATE: 'Updated Date',
  MEETING_CONDITION_REMARKS: 'Remarks (if any)',
  MEETING_CONDITION_TITLE: 'Meeting Conditions',
  MEET_CONDITION_DEADLINE: 'Meet Conditions Deadline',
  CONTACT_PERSON_NAME: 'Contact Person Name',
  CONTACT_PERSON_EMAIL: 'Contact Person Email',
  QUALIFICATION_CHECK_STATUS: 'Status of Qualification Verification',
  QUALIFICATION_CHECK_SUBMIT_DATE: 'Request Date',
  QUALIFICATION_CHECK_UPDATE_DATE: 'Updated Date',
  QUALIFICATION_CHECK_REMARKS: 'Remarks (if any)',

  REGISTRATION_PREPARATION: 'Registration Preparation',
  STUDENT_VISA: 'Student Visa',
  STUDENT_HALLS_OF_RESIDENCE: 'Student Halls of Residence',
  DOCUMENTS_REQUIRED_FOR_QUALIFICATION_CHECK:
    'Documents Required for Qualification Verification',
  STATUS_OF_QUALIFICATION_VERIFICATION: 'Status of Qualification Verification',

  POST_SECONDARY_QUALIFICATION: 'Post-secondary Qualification',
  ENGLISH_LANGUAGE_AND_OTHER_TEST: 'English Language / Other Test',
  VERIFICATION_STATUS: 'Verification Status',

  SUBMIT_CONDITION_CONFIRM_TITLE:
    'Are you sure you want to submit this meeting conditional application?',
  SUBMIT_CONDITION_CONFIRM_CONTENT:
    'By submitting, your application will be processed by department. This action cannot be reversed.',

  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
};
export const studentVisaInformation = `
<p>Please note that you need to obtain a valid student visa (e-Visa) before you complete programme registration. The Hong Kong
Immigration Department takes at least six weeks to process your student visa application upon receiving all the necessary documents, and it may take longer during the summer peak season. Therefore, it is strongly recommended that you submit your <b><a target="_blank" href="https://www.polyu.edu.hk/aradm/rpg/instructions_for_applying_student_visa.pdf" class="color">Student Visa Application
Form</a></b> and all the required documents <b>by express post within 10 working days of the issuance date of your offer or conditional offer of admission</b>. When you collect your student identity card at PolyU, you will need to present the original of your travel document with the e-Visa (i.e. Notification Slip for Entry Visa 1 Permit) and the
landing slip issued by the Hong Kong Immigration Department.</p>

<p>Once your visa application is approved, you will receive an email notification on how to download your e-Visa and No Objection Letter (if
applicable) from the Hong Kong Immigration Department's website. If you are given a conditional offer, you will only receive
the email notification after you have met the condition(s) of your admission offer.</p><p>If you have any questions, please contact the Academic Registry at email ar.rpg@polyu.edu.hk or contact number +852 2333 0600.</p>`;

export const studentHallInformation = `
<p>The University is facing an acute shortage of hall places. Only full-time UGC-funded research students within the normal duration of
study are eligible for about one year of residence (from the check-in date to the end of the 12th month) in University-managed
accommodation (including the Student Halls and off-campus housing), subject to availability. Students can make alternative
accommodation arrangements if necessary. Please click <a class="webside-link" target="_blank" href="https://www.polyu.edu.hk/sao/student-resources-and-support-section/residential-life/university-managed-accommodations/">here</a> for more information.</p>
<p>To apply for a place in the Student Halls of Residence, you need to first accept the PolyU offer and settle the required fees. Then visit
<a class="webside-link" target="_blank" href="https://www.polyu.edu.hk/sao/student-resources-and-support-section/residential-life/hall-admission/hall-applications/prospective-local-full-time-undergraduate-students/">here</a> to submit your hall application or to accept hall offer. Successful applicants will be informed of the application result by email
around 2-4 weeks in advance of the expected check-in date.</p>
<p>If you have any enquiries concerning the hall application, please contact the Student Halls of Residence by email to
<i class="email-link">student.halls@polyu.edu.hk</i>.</p>`;

export const documentRequiredInformation20240203 = `
<p>Before proceeding to programme registration, you are required to arrange the following documents to be sent directly by the issuing
authority to the Academic Registry of PolyU for verification. <b>Please note that all qualifications (except those obtained from PolyU)
mentioned in your application should be submitted for verification. Failure to do so or any discrepancies found may lead to
nullification of your offer and registration at the University. Fees paid will not be refunded.</b></p>

<p class="marg-text">Degree Certificates/Diplomas and Official Transcripts
</p>

<table>
    <tr>
    <td>Degree Certificates/Diplomas</td>
    <td>
    <ul>
    <li>
    <p>The officially certified true copies of degree certificates/diplomas should be sent directly by the issuing authority to PolyU.</p>
    <p class="pd">Final year students whose awards are confirmed but will be formally conferred after programme
commencement are required to submit a letter of graduation certification issued by the Registrar or an
authorised official of your institution. The letter should include your name, date of birth and the title and
signature of an authorised official with an official stamp of your institution which confirms that you have
fulilled all the graduation requirements, preferably with the date of conferment and award classification.</p>
</li>
<li>
<div><p class="pd">For degrees awarded by universities in the Chinese Mainland/recognised by the Ministry of Education
from Chinese Mainland, your Degree Certificate (學位證書) and Academic Credential (畢業證書) will be
verified via official online platforms directly. Please input the Online Verification Code (線上驗證碼) issued
by the China Academic Degrees and Graduate Education Development Center (教育部學位與研究生教育，發展中心) of your Degree Certificate (學位證書) and the Online Verification Code (線上驗證碼) of your
Academic Credential (畢業證書) issued by the CHESICC (學信網) at <a>RPgAdmission</a>. Since the Online
Verification Code (線上驗證碼) of your Academic Credential (畢業證書) will expire 180 days after it is sent
to you, please ensure that the code is still valid at least 14 days before the first day of your online programme registration
period and extend the validity period of your code (<a href="https://www.chsi.com.cn/xlcx/rhyg.jsp">https://www.chsi.com.cn/xlcx/rhyg.jsp</a>), if deemed necessary.</p>
<p>Final year students or students who graduated before 2008, your Degree Certificate (學位證書) cannot be
verified online. You should ask your awarding institution to send us a letter of graduation issued by the
Registrar or an authorised official of your institution. The letter should include your name, date of birth
and the title and signature of an authorised official with an official stamp of your institution which confirms
that you have fufilled all the graduation requirements, preferably with the date of conferment and award
classification.</p></div>
</li>
</ul>
</td>
    </tr>
    
    <tr>
    <td>
Official Final Transcripts    
</td>
<td>
<ul>
<li>
<div>
<p>The official final transcripts should be sent directly by the issuing authority to PolyU. The transcript should
include results of all the coursework and project(s), a final GPA/grade/score together with an explanation
of the grading system.</p>
<p>If your final score and GPA or the explanation of the grading system is not shown on your final transcript,
please request your institution to submit a letter of certificate certifying your final score and GPA together
with an explanation of the grading system issued by the Registrar or an authorised official of your
institution. The letter should include your name, date of birth and the title and signature of an authorised
official with an official stamp of your institution.</p>

</div>
</li>
</ul>
</td>
    </tr>
</table>

<ul>
<li><p>You are strongly advised to arrange the above documents to be sent directly by a central unit of the issuing authority (e.g. Registry or
equivalent) to PolyU as soon as possible (i.e. right after accepting the admission offer).</p></li>
<li><p><span class="important-note">Electronic copies are highly preferred.</span> Please ask the issuing authority to send us the electronic copies of your documents using
an official email account (e.g. ar.rpg@polyu.edu.hk).</p></li>
<li><p>If the issuing authority cannot send us an electronic version of the official documents, please ask them to send us hard copy of the
official documents by express post. The envelope should be sealed, signed and stamped by the Registrar or by an authorised official
of your institution.</p>
<table>
<tr>
<td class="pl-2">Email Address:</td>
<td class="pl-2"><a class="email-link">ar.rpg@polyu.edu.hk</a></td>
</tr>
<tr>
<td class="pl-2">Mailing Address:</td>
<td class="pl-2">Academic Registry, M101, Li Ka Shing Tower, The Hong Kong Polytechnic University, Kowloon, Hong Kong</td>
</tr>
<tr>
<td class="pl-2">Contact Number:</td>
<td class="pl-2">+852 2333 0600</td>
</tr>
</table>
</li>
<li><p>The University will only accept originals or copies of the documents that have been duly declared as true copies by an authorised
party, which includes a lawyer, a notary public*, or a Consulate General.</p></li>
<li><p>Official certified translation in English is required for transcripts and certificates that are not in English or Chinese. The translator
should sign and stamp on both (i) the translation and (ii) the official document and certify that the translation is accurate and
completed by an authorised party as stated above.</p></li>
<li><p>All documents submitted will not be returned. Please do not send us any <span class="important-note">originals which cannot be re-issued</span>.</p></li>
<li><p>You may be asked to re-submit any official certification of qualifications (e.g. transcript or degree award certificate, etc.) if deemed
necessary.</p></li>
</ul>
<p><i>* Declaration from a notary public (e.g. a Commissioner of Oaths at Home Affairs Enquiry Centres in Hong Kong) will only be accepted
on a case-by-case basis with strong justification.</i></p>

<p class="marg-text">Score Reports of GMAT, GRE, IELTS or TOEFL</p>
<p><b>If your score reports can be verified online</b>, you should inform the relevant test/examination provider to release the right to PolyU to verify your results online. Below are the PolyU codes for GMAT, GRE and TOEFL:</p>
<p>
  <table>
  <tr>
  <td>GMAT</td><td>CB8</td>
  </tr><tr>
  <td>GRE</td><td>3404</td>
  </tr><tr>
  <td>TOEFL*</td><td>0732</td>
  </tr>
  </table>
</p>
<p>Please make sure that online results can be verified before your assigned online programme registration period.</p>
<p>IELTS score report could be verified online without an access code. You are therefore not required to request IELTS to send us the hard
copy report unless you are asked to do so.</p>
<p  class="pb-24"><b>If your score reports CANNOT be verified online</b>, you should ask the relevant test/examination provider to send us the official result
slip for our verification.</p>
</p>
`;

export const documentRequiredInformation2025010203 = `
<p>
  Please refer to the Guidelines on Submission of Required Documents for
  Qualification (<a
    target="_blank"
    rel="noreferrer"
    href="https://www.polyu.edu.hk/gs/docdrive/Others/guidelines_qualification_verification_rpg.pdf"
    style="color: blue; text-decoration: underline"
    >link</a
  >) for details.
  <b
    >Please note that all qualifications(except those obtained from PolyU)
    mentioned in your application should be submitted for verification.
    Failure to do so or any discrepancies found may lead to nullification
    of your offer and registration at the University. Fees paid will not
    be refunded.</b
  >
  You can only proceed with online programme registration after completion
  of qualification verification and approval of student visa application
  (if applicable).
</p>
`;
